import moment from "moment";
import { apiRequest } from "../action/api.action"
import {
  FETCH_VESSELS,
  FETCH_VESSELS_FAILURE,
  FETCH_VESSELS_SUCCESS,
  FETCH_SERVICE_VESSELS,
  FETCH_SERVICE_VESSELS_FAILURE,
  FETCH_SERVICE_VESSELS_SUCCESS,


} from "../action/company-vessel-chart.action";
import { FETCH_AREAS, FETCH_AREAS_FAILURE, FETCH_AREAS_SUCCESS, FETCH_DEFICIENCY_CODES, FETCH_DEFICIENCY_CODES_FAILURE, FETCH_DEFICIENCY_CODES_SUCCESS } from "../action/filter.action";

export const companyVesselFlow = ({ dispatch }) => next => action => {

  next(action)


  if (action.type === FETCH_SERVICE_VESSELS) {

    let deficiencyArea = encodeURI(action.payload.filter?.deficiencyArea || "");
    let dateFrom = action.payload.filter.dateFrom ? moment(action.payload.filter.dateFrom).format('DD.MMM.YYYY') : "";
    let dateTo = action.payload.filter.dateTo ? moment(action.payload.filter.dateTo).format('DD.MMM.YYYY') : "";
    let areas = action.payload.filter.areas
      ? action.payload.filter.areas.map(area => `areas=${encodeURIComponent(area)}`).join("&")
      : ""; // Convert areas to an array parameter    let myFleet = action.payload.filter.myFleet ? action.payload.filter.myFleet : false;
    let myFleet = action.payload.filter.myFleet ? action.payload.filter.myFleet : false;
    let myPort = action.payload.filter.myPort ? action.payload.filter.myPort : false;
    let myProductFleet = action.payload.filter.myProductFleet ? action.payload.filter.myProductFleet : false;
    let companyFleet = action.payload.filter.companyFleet ? action.payload.filter.companyFleet : false;
    let observedDeficiency = action.payload.filter.observedDeficiency ? action.payload.filter.observedDeficiency : false;
    let companyId = action.payload.filter.companyId ? action.payload.filter.companyId : "";


    let url = `/api/v1/deficiencies/list?companyId=${companyId}&myProductFleet=${myProductFleet}&companyFleet=${companyFleet}&observedDeficiency=${observedDeficiency}&servedPorts=${myPort}&myFleet=${myFleet}&etaFrom=${dateFrom}&etaTo=${dateTo}&deficiencyArea=${deficiencyArea}&${areas}&draw=${encodeURI(action.payload.draw)}&orderByColumn=${encodeURI(action.payload.orderByColumn)}&orderDir=${encodeURI(action.payload.orderDir)}&start=${encodeURI(action.payload.start)}&length=${encodeURI(action.payload.length)}`;

    dispatch(apiRequest('GET', url, null, FETCH_SERVICE_VESSELS_SUCCESS, FETCH_SERVICE_VESSELS_FAILURE));
  } else if (action.type === FETCH_VESSELS) {

    let keyword = action.payload.keyword ? action.payload.keyword : ""

    let url = `/api/v1/equipments/vessels?keyword=${keyword}&draw=${encodeURI(action.payload.draw)}&orderByColumn=${encodeURI(action.payload.orderByColumn)}&orderDir=${encodeURI(action.payload.orderDir)}&start=${encodeURI(action.payload.start)}&length=${encodeURI(action.payload.length)}`;
    dispatch(apiRequest('GET', url, null, FETCH_VESSELS_SUCCESS, FETCH_VESSELS_FAILURE));
  } else if (action.type === FETCH_AREAS) {
    let url = `/api/v1/areas/list`
    dispatch(apiRequest('GET', url, null, FETCH_AREAS_SUCCESS, FETCH_AREAS_FAILURE));
  } else if (action.type === FETCH_DEFICIENCY_CODES) {
    let url = `/api/v1/deficiencies/code-list`
    dispatch(apiRequest('GET', url, null, FETCH_DEFICIENCY_CODES_SUCCESS, FETCH_DEFICIENCY_CODES_FAILURE ));
  }

};

export const companyVesselMdl = [companyVesselFlow];